module.exports = __webpack_public_path__ + "media/2.57d3cd3c.wav";